import React, { useState, useContext } from "react";
import { registerLocale } from "react-datepicker";
import DatePicker from "../../../components/DatePickerInput";
import "react-datepicker/dist/react-datepicker.css";
import ar from "date-fns/locale/es";
import FuncionesContext, {
  parseISOString,
} from "../../../context/FuncionesContext";
import { getAtributo } from "../../../context/FuncionesContext";
import Nullifier from "../../../components/Nullifier";
registerLocale("ar", ar);

const InputDate = ({
  data,
  cab,
  campokey,
  id_elemento,
  updateState,
}) => {
  const { superSubmit } = useContext(FuncionesContext);

  const [value, setValue] = useState(parseISOString(data[campokey]));
  const [lastValue, setLastvalue] = useState(data[campokey]);
  const [updateId, setUpdateId] = useState(getAtributo("update_id", data, cab));

  const permite_null =
    data[cab.id_a + "_permite_null"] === "s" || cab.permite_null === "s";
  const disabled = data[cab.id_a + "_disabled"] === "s" || cab.disabled === "s";

  const className = data[cab.id_a + "_className"] ?? cab.className;

  const handleCancelar = () => {
    setValue(lastValue);
  };

  const handleGuardar = async (date) => {
    const valor = date;
    if (value?.toDateString() === valor?.toDateString()) return;
    setValue(valor);
    if (!permite_null) {
      if (valor === null) return;
    }

    const valorParseado =
      valor === null
        ? null
        : valor.toISOString().replace(/T/, " ").replace(/\..+/, "");

    const { id_a } = cab;

    await superSubmit({
      valor: valorParseado,
      id_a,
      update_id: updateId,
      handleCancelar,
      cab,
      data,
      //  indiceData,
    })
      .then((result) => {
        setLastvalue(value);
        // const parsedValor = valor === null ? null : valor.toISOString();
        if (!updateId) {
          updateState(cab.update_id_alias, result.data.registro.id);
          setUpdateId(result.data.registro.id);
        }
        updateState(campokey, valor);
        return result;
      })
      .catch((err) => {
        console.log("Cancelado ", err);
      });
  };

  return (
    <div id={id_elemento} className="tarjeta_grid_item_label_item">
      <DatePicker
        selected={value}
        fechaMinima={getAtributo("fecha_minima", data, cab)}
        onChange={handleGuardar}
        disabled={disabled}
        //isClearable={permite_null}
        dateFormat={cab.fecha_formato ?? "dd-MM-yyyy"}
        locale="ar"
        placeholderText=" sin fecha "
        // withPortal={true}
        showYearDropdown
        className={`input_fecha ${className}`}
      />
      {permite_null ? (
        <Nullifier
          onClick={() => handleGuardar(null)}
          className="columna_input_date_null"
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default InputDate;
